export const measurePerformanceUrl = 'https://help.gtowizard.com/measure-performance/'
export const helpCenterUrl = 'https://help.gtowizard.com/'
export const discordInviteUrl = 'https://discord.com/invite/ht3QxrP'
export const gtoWizardTermsUrl = 'https://gtowizard.com/terms/'
export const gtoWizardPrivacyUrl = 'https://gtowizard.com/privacy/'
export const discordInviteLinkUrl = 'https://discord.gg/ht3QxrP'
export const discordAccountPaymentsUrl =
  'https://discord.com/channels/756231695522332692/1032779533805428837'
export const analyzeGuideUrl = 'https://blog.gtowizard.com/analyze-mode/'
export const rakesGuidUrl =
  'https://blog.gtowizard.com/update-customizable-raked-solutions-with-gto-wizard-ai/'
export const analyzedHandsExplainedUrl = 'https://blog.gtowizard.com/analyzed-hands/'
export const getMostOfAnalyzerUrl = 'https://blog.gtowizard.com/how-to-study-analyzed-hands/'
export const uploadsExplainedUrl = 'https://blog.gtowizard.com/upload-hands/'
export const uploadStatusesExplainedUrl = 'https://blog.gtowizard.com/upload-hands/#what_do'
export const solutionBrowserUrl = 'https://help.gtowizard.com/solution-browser/'
export const aboutSolutionsUrl = 'https://blog.gtowizard.com/status-and-info-about-our-solutions/'
export const analyzerUrl = 'https://help.gtowizard.com/analyze-mode-guide/'
export const filterSubsetsUrl = 'https://blog.gtowizard.com/poker-subsets-and-abstractions/'
export const trainerTipsTricksUrl = 'https://help.gtowizard.com/practice-mode-overview'
export const trainerHowToUseUrl = 'https://help.gtowizard.com/how-to-use-the-trainer/'
export const rangeBuilderHowToUseUrl = 'https://help.gtowizard.com/how-to-use-the-range-builder/'
export const trainerStatsUrl = 'https://help.gtowizard.com/measure-performance/'
export const trainerDrillsUrl = 'https://help.gtowizard.com/manage-training-drills/'
export const rangesTabUrl = 'https://help.gtowizard.com/ranges-tab/'
export const breakdownTabUrl = 'https://help.gtowizard.com/breakdown-tab/'
export const eqChartUrl = 'https://blog.gtowizard.com/what-is-equity-in-poker/#equity_graphs'
export const raCompareCombosUrl = 'https://gtowizard.com/glossary/combo/'
export const raCompareEvUrl = 'https://gtowizard.com/glossary/expected-value-ev/'
export const raCompareEqUrl = 'https://gtowizard.com/glossary/equity/'
export const raCompareEqrUrl = 'https://gtowizard.com/glossary/equity-realization-eqr/'
export const bubbleFactorUrl =
  'https://blog.gtowizard.com/what-is-the-bubble-factor-in-poker-tournaments/'
export const icmPkoUrl =
  'https://blog.gtowizard.com/the-theory-of-progressive-knockout-tournaments/'
export const customSolutionsUrl = 'https://blog.gtowizard.com/introducing-gto-wizard-ai/'
export const aiGuidesUrl = 'https://help.gtowizard.com/custom-solving-overview/'
export const howToBuildCustomSolutionsUrl =
  'https://help.gtowizard.com/how-to-build-custom-solutions/'
export const preflopAiUrl =
  'https://blog.gtowizard.com/introducing-gto-wizard-ai-heads-up-preflop-solver/'
export const howToEditRangesUrl =
  'https://help.gtowizard.com/how-to-build-custom-solutions/#edit_ranges'
export const betSizesUrl =
  'https://help.gtowizard.com/how-to-build-custom-solutions/#building_the_betting_tree'
export const savingLoadingGuidesUrl =
  'https://help.gtowizard.com/how-to-build-custom-solutions/#saving_parameters'
export const trainAgainstCustomSolutionsUrl =
  'https://help.gtowizard.com/how-to-train-against-custom-solutions/'
export const rngTrainerPreferencesUrl = 'https://help.gtowizard.com/practice-mode-overview/#rng'
export const whatIsPotOddsUrl = 'https://blog.gtowizard.com/what-are-pot-odds-in-poker/'
export const icmPressureGuideUrl = 'https://blog.gtowizard.com/icm-basics/'
export const evCompareTooltipUrl =
  'https://blog.gtowizard.com/how-to-leverage-gto-wizards-ev-comparison-tool/'
export const evCompareTooltipYouTubeUrl = 'https://youtu.be/lHnh3vlmEZ4'
export const donkBettingTooltipUrl = 'https://gtowizard.com/glossary/donk-bet/'
export const geometricBettingUrl = 'https://blog.gtowizard.com/pot-geometry/'
export const howToCalculateRaiseSizeUrl =
  'https://blog.gtowizard.com/how-to-calculate-raises-in-poker/'
export const nodelockingHowToUseUrl = 'https://help.gtowizard.com/how-to-use-nodelocking/'
export const evConverterBountiesUrl =
  'https://blog.gtowizard.com/bounty-models-explained-solving-knockout-tournaments/'
export const evConverterIcmUrl = 'https://blog.gtowizard.com/icm-basics/'
export const solutionStatusUrl =
  'https://help.gtowizard.com/how-to-use-the-hand-history-analyzer/#!/statuses'
export const gtoBlogUrl =
  'https://blog.gtowizard.com/major-upgrade-gto-reports-have-arrived-plus-tons-of-new-features/#gto_reports_analyze_compare_improve'
